import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext.jsx';
import { EVENTS } from '@shared/events.js';
import CubeMark from '../components/CubeMark.jsx';

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    nickname: '',
    email: '',
    password: '',
    started_at: '',
    main_event: '3x3',
    course_code: '',
    invite_code: '',
  });
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      const user = await register(form);
      navigate(user.role === 'coach' ? '/coach' : '/', { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-8 bg-ink-950 relative overflow-hidden">
      <div className="absolute inset-0 hairlines opacity-60" />
      <div className="w-full max-w-md relative">
        <div className="text-center mb-8">
          <div className="flex justify-center mb-5">
            <CubeMark size={52} />
          </div>
          <h1 className="text-2xl font-bold text-slate-100">创建账号</h1>
          <p className="text-sm text-slate-500 mt-1.5">填完就能开始第一次打卡</p>
        </div>
        <div className="card p-6 shadow-2xl">
          {error && (
            <div className="mb-4 text-sm bg-danger/10 text-danger border border-danger/20 rounded-xl px-3.5 py-2.5">
              {error}
            </div>
          )}
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="label">昵称</label>
              <input className="input" value={form.nickname} onChange={set('nickname')} placeholder="学生/教练如何称呼你" required />
            </div>
            <div>
              <label className="label">邮箱</label>
              <input className="input" type="email" value={form.email} onChange={set('email')} placeholder="you@example.com" required />
            </div>
            <div>
              <label className="label">密码（至少 6 位）</label>
              <input className="input" type="password" value={form.password} onChange={set('password')} required />
            </div>
            <div>
              <label className="label">开始学习魔方的日期</label>
              <input className="input" type="date" value={form.started_at} onChange={set('started_at')} />
            </div>
            <div>
              <label className="label">当前主项目</label>
              <select className="input" value={form.main_event} onChange={set('main_event')}>
                {EVENTS.map((e) => (
                  <option key={e.key} value={e.key}>{e.name}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="label">课程码（学生必填）</label>
              <input className="input" value={form.course_code} onChange={set('course_code')} placeholder="付费后教练提供的课程码" />
              <p className="text-[11px] text-slate-500 mt-1">报名课程后向教练获取；教练注册请填下方邀请码</p>
            </div>
            <div>
              <label className="label">教练邀请码（学生可不填）</label>
              <input className="input" value={form.invite_code} onChange={set('invite_code')} placeholder="注册为教练时填写" />
            </div>
            <button className="btn-primary w-full" disabled={busy}>
              {busy ? '注册中…' : '注册'}
            </button>
          </form>
          <div className="mt-5 pt-5 border-t border-slate-700/50 text-sm text-slate-400">
            已有账号？
            <Link to="/login" className="text-accent hover:underline ml-1">去登录</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
